export const getPriorityBadgeStatus = (priority) => {
  const priorityMap = {
    urgent: 'critical',
    high: 'warning',
    medium: 'attention',
    low: 'success'
  };
  return priorityMap[priority?.toLowerCase()] || 'default';
};

export const getPriorityLabel = (priority) => {
  if (!priority) return null;
  return priority.charAt(0).toUpperCase() + priority.slice(1);
};

export const PRIORITY_OPTIONS = [
  { label: 'Urgent', value: 'urgent' },
  { label: 'High', value: 'high' },
  { label: 'Medium', value: 'medium' },
  { label: 'Low', value: 'low' }
];
